/* FACEPLANT runtime for Shopify. Renders the page templates, handles state, faces and cart. */
(function(){
var FACES = window.__FP_FACES || {};
var RM = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
var NS = 'http://www.w3.org/2000/svg';
var HOLE = /\{\{\s*([^}]+?)\s*\}\}/g, WHOLE = /^\{\{\s*([^}]+?)\s*\}\}$/;

if (window.__FP_FACE_CSS) { var st = document.createElement('style'); st.textContent = window.__FP_FACE_CSS; document.head.appendChild(st); }

class FPFace extends HTMLElement {
  static get observedAttributes() { return ['face']; }
  connectedCallback() {
    if (this._init) return; this._init = 1;
    this.shown = this.getAttribute('face') || 'good'; this.draw(this.shown);
    if (this.getAttribute('idle') !== 'false' && !RM) this.idle();
  }
  disconnectedCallback() { clearTimeout(this.it); }
  draw(k) { this.innerHTML = FACES[k] || FACES[k === 'insuff' ? 'low' : 'good'] || ''; }
  attributeChangedCallback(n, o, v) {
    if (!this._init || o === v) return;
    clearTimeout(this.bt);
    if (RM) { this.shown = v; this.draw(v); return; }
    this.draw('blink'); var s = this;
    this.bt = setTimeout(function(){ s.shown = s.getAttribute('face'); s.draw(s.shown); }, 140);
  }
  idle() {
    var s = this;
    this.it = setTimeout(function(){
      if (['low','insuff','hightemp','abund'].indexOf(s.shown) < 0) { s.draw('blink'); setTimeout(function(){ s.draw(s.shown); }, 140); }
      s.idle();
    }, 1400 + Math.random() * 2600);
  }
}
if (!customElements.get('fp-face')) customElements.define('fp-face', FPFace);

function res(p, sc) {
  p = p.trim();
  if (p === 'true') return true; if (p === 'false') return false;
  if (/^-?\d+(\.\d+)?$/.test(p)) return +p;
  var v = sc, parts = p.split('.');
  for (var i = 0; i < parts.length; i++) { if (v == null) return undefined; v = v[parts[i]]; }
  return v;
}
function interp(s, sc) { return s.replace(HOLE, function(m, p){ var v = res(p, sc); return v == null ? '' : String(v); }); }
function asset(v) { return (typeof v === 'string' && v.indexOf('assets/') === 0) ? (window.FP_ASSETS || '') + v.slice(7) : v; }

function build(nodes, sc, ctx, parent) {
  for (var i = 0; i < nodes.length; i++) {
    var n = nodes[i];
    if (n.nodeType === 3) { parent.appendChild(document.createTextNode(interp(n.nodeValue, sc))); continue; }
    if (n.nodeType !== 1) continue;
    var tag = n.localName;
    if (tag === 'sc-for') {
      var lm = (n.getAttribute('list') || '').match(WHOLE); var list = lm ? res(lm[1], sc) : null; var as = n.getAttribute('as') || 'item';
      if (list && list.length) for (var j = 0; j < list.length; j++) { var cs = Object.create(sc); cs[as] = list[j]; cs.$index = j; build(n.childNodes, cs, ctx, parent); }
      continue;
    }
    if (tag === 'sc-if') { var vm = (n.getAttribute('value') || '').match(WHOLE); if (vm && res(vm[1], sc)) build(n.childNodes, sc, ctx, parent); continue; }
    var el;
    if (tag === 'dc-import') {
      el = document.createElement('fp-face');
      var fm = (n.getAttribute('face') || '').match(WHOLE); el.setAttribute('face', fm ? String(res(fm[1], sc)) : (n.getAttribute('face') || 'good'));
      var im = (n.getAttribute('idle-blink') || '').match(WHOLE); if (im && res(im[1], sc) === false) el.setAttribute('idle', 'false');
      el.setAttribute('style', 'display:block;' + interp(n.getAttribute('style') || '', sc));
      el._t = { face: el.getAttribute('face'), style: el.getAttribute('style') };
      parent.appendChild(el); continue;
    }
    if (tag === 'image-slot') {
      el = document.createElement('div'); el.setAttribute('style', 'width:100%;height:100%;background:#E3E2DC'); el._t = { style: el.getAttribute('style') };
      parent.appendChild(el); continue;
    }
    el = n.namespaceURI === NS ? document.createElementNS(NS, tag) : document.createElement(tag);
    el._t = {};
    for (var a = 0; a < n.attributes.length; a++) {
      var at = n.attributes[a], name = at.name, val = at.value, low = name.toLowerCase();
      if (low.indexOf('hint-') === 0) continue;
      var wm = val.match(WHOLE);
      if (low.indexOf('on') === 0 && wm) { var fn = res(wm[1], sc); if (typeof fn === 'function') { name = 'data-fp-' + low.slice(2); val = String(ctx.h.push(fn) - 1); } else continue; }
      else if (low === 'ref' && wm) { var r = res(wm[1], sc); if (!r) continue; name = 'data-fp-ref'; val = String(ctx.r.push(r) - 1); }
      else if (low === 'style-hover') { name = 'data-hover'; val = interp(val, sc); }
      else if (wm) { var rv = res(wm[1], sc); if (rv == null || rv === false) continue; val = String(rv); }
      else val = interp(val, sc);
      if (low === 'src') val = asset(val);
      el.setAttribute(name, val); el._t[name] = val;
    }
    build(n.childNodes, sc, ctx, el);
    parent.appendChild(el);
  }
}

function syncAttrs(a, b) {
  var t = a._t || (a._t = {}), bt = b._t || {};
  for (var k in t) if (!(k in bt)) { a.removeAttribute(k); delete t[k]; }
  for (var k2 in bt) if (t[k2] !== bt[k2]) { a.setAttribute(k2, bt[k2]); t[k2] = bt[k2]; if (k2 === 'value' && a.value !== undefined) a.value = bt[k2]; }
}
function morph(a, b) {
  if (a.nodeType !== b.nodeType || a.nodeName !== b.nodeName) { a.parentNode.replaceChild(b, a); return; }
  if (a.nodeType === 3) { if (a.nodeValue !== b.nodeValue) a.nodeValue = b.nodeValue; return; }
  if (a.nodeType !== 1) return;
  syncAttrs(a, b);
  if (a.localName === 'fp-face') return;
  morphKids(a, b);
}
function morphKids(a, b) {
  var ac = Array.prototype.slice.call(a.childNodes), bc = Array.prototype.slice.call(b.childNodes);
  for (var i = 0; i < bc.length; i++) { if (ac[i]) morph(ac[i], bc[i]); else a.appendChild(bc[i]); }
  for (var j = bc.length; j < ac.length; j++) ac[j].remove();
}

window.FP_cartAdd = function(colours) {
  var V = window.FP_VARIANTS || {};
  var items = colours.map(function(c){ return { id: V[c], quantity: 1 }; }).filter(function(x){ return x.id; });
  if (!items.length) return;
  fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) })
    .then(function(){ return fetch('/cart.js'); }).then(function(r){ return r.json(); })
    .then(function(c){ (window.FP_instances || []).forEach(function(i){ i.setState({ cart: c.item_count }); }); })
    .catch(function(){});
};

window.FP = { mount: function(key) {
  var tpl = document.getElementById('fp-tpl-' + key).textContent;
  var doc = new DOMParser().parseFromString('<body>' + tpl + '</body>', 'text/html');
  var nodes = Array.prototype.slice.call(doc.body.childNodes);
  var root = document.getElementById('fp-root-' + key);
  var inst, ctx = { h: [], r: [] }, queued = false, prev = null, mounted = false;
  class Base {
    constructor() { this.props = {}; this.state = {}; }
    setState(u) { var nx = typeof u === 'function' ? u(this.state, this.props) : u; if (!nx) return; if (!prev) prev = this.state; this.state = Object.assign({}, this.state, nx); schedule(); }
    forceUpdate() { schedule(); }
  }
  var React = { createRef: function(){ return { current: null }; }, createElement: function(){ return null; } };
  var Cls = window['FP_LOGIC_' + key](Base, React);
  inst = new Cls();
  (window.FP_instances = window.FP_instances || []).push(inst);
  function render() {
    ctx = { h: [], r: [] };
    var vals = inst.renderVals(); var frag = document.createElement('div');
    build(nodes, vals, ctx, frag);
    if (!mounted) { while (frag.firstChild) root.appendChild(frag.firstChild); mounted = true; }
    else morphKids(root, frag);
    root.querySelectorAll('[data-fp-ref]').forEach(function(el){ var r = ctx.r[+el.getAttribute('data-fp-ref')]; if (r) r.current = el; });
  }
  function schedule() {
    if (queued || !mounted) return; queued = true;
    Promise.resolve().then(function(){ queued = false; var p = prev; prev = null; render(); if (inst.componentDidUpdate) inst.componentDidUpdate({}, p || {}); });
  }
  function fire(type) { return function(e){ var el = e.target.closest && e.target.closest('[data-fp-' + type + ']'); if (el && root.contains(el)) { var f = ctx.h[+el.getAttribute('data-fp-' + type)]; if (f) f(e); } }; }
  root.addEventListener('click', fire('click'));
  root.addEventListener('input', fire('change'));
  root.addEventListener('change', fire('change'));
  root.addEventListener('scroll', fire('scroll'), true);
  root.addEventListener('mouseover', function(e){ var el = e.target.closest && e.target.closest('[data-hover]'); if (el && !el._hov) { el._hov = el.getAttribute('style') || ''; el.setAttribute('style', el._hov + ';' + el.getAttribute('data-hover')); } });
  root.addEventListener('mouseout', function(e){ var el = e.target.closest && e.target.closest('[data-hover]'); if (el && el._hov != null && !el.contains(e.relatedTarget)) { el.setAttribute('style', (el._t && el._t.style) || el._hov); el._hov = null; } });
  render();
  if (inst.componentDidMount) inst.componentDidMount();
  fetch('/cart.js').then(function(r){ return r.json(); }).then(function(c){ inst.setState({ cart: c.item_count }); }).catch(function(){});
} };
})();
